import { brandLogo } from '@/assets/images';

export default function Contact() {
  return (
    <section id="contacto" className="py-24 md:py-32 bg-cream-50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <p className="text-[11px] tracking-widest-xl text-ink-500 mb-6">VISÍTANOS</p>
          <h2 className="font-display text-5xl md:text-7xl text-ink-900 mb-8">Ven a conocernos</h2>
          <div className="w-16 h-px bg-ink-900/40 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-stretch">
          <div className="bg-ink-900 p-10 md:p-14 flex flex-col justify-between">
            <div>
              <img
                src={brandLogo}
                alt="SANO Moda"
                title="SANO Moda · Llíria, Valencia"
                className="h-7 w-auto brightness-0 invert mb-8"
              />
              <div className="space-y-8">
                <div>
                  <p className="text-[10px] tracking-widest text-cream-50/45 mb-3">DIRECCIÓN</p>
                  <p className="text-cream-50/85 text-base leading-relaxed">
                    Calle San Vicente Ferrer, 34<br />
                    46160 Llíria, Valencia
                  </p>
                </div>
                <div>
                  <p className="text-[10px] tracking-widest text-cream-50/45 mb-3">TELÉFONO</p>
                  <a href="tel:+34962782616" className="text-cream-50/85 text-base hover:text-cream-50 transition-colors cursor-pointer">
                    962 782 616
                  </a>
                </div>
                <div>
                  <p className="text-[10px] tracking-widest text-cream-50/45 mb-3">EMAIL</p>
                  <a href="mailto:sanoropa@gmail.com" className="text-cream-50/85 text-base hover:text-cream-50 transition-colors cursor-pointer">
                    sanoropa@gmail.com
                  </a>
                </div>
                <div>
                  <p className="text-[10px] tracking-widest text-cream-50/45 mb-3">INSTAGRAM</p>
                  <a href="https://instagram.com/ropasano" target="_blank" rel="noreferrer" className="text-cream-50/85 text-base hover:text-cream-50 transition-colors cursor-pointer">
                    @ropasano
                  </a>
                </div>
                <div>
                  <p className="text-[10px] tracking-widest text-cream-50/45 mb-3">FACEBOOK</p>
                  <a href="https://www.facebook.com/share/1JXngLyhbp/?mibextid=wwXIfr" target="_blank" rel="noreferrer" className="text-cream-50/85 text-base hover:text-cream-50 transition-colors cursor-pointer">
                    SANO Moda
                  </a>
                </div>
                <div>
                  <p className="text-[10px] tracking-widest text-cream-50/45 mb-3">HORARIO</p>
                  <p className="text-cream-50/70 text-sm leading-relaxed">
                    Lunes a Sábado · 10:00 – 13:30 &nbsp;/&nbsp; 17:00 – 20:30<br />
                    Domingo · Cerrado
                  </p>
                </div>
              </div>
            </div>
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=Calle+San+Vicente+Ferrer+34+Lliria+Valencia"
              target="_blank"
              rel="noreferrer"
              className="mt-10 inline-flex items-center gap-3 px-9 py-4 bg-cream-50 text-ink-900 text-[11px] tracking-widest hover:bg-cream-200 transition-all duration-500 cursor-pointer whitespace-nowrap self-start"
            >
              CÓMO LLEGAR
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          <div className="min-h-[500px] overflow-hidden">
            <iframe
              title="Ubicación SANO"
              src="https://www.google.com/maps?q=Calle+San+Vicente+Ferrer+34,+Lliria,+Valencia&output=embed"
              className="w-full h-full min-h-[500px] border-0 grayscale"
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}